import * as LaunchDarkly from 'launchdarkly-react-client-sdk'

export const defaultFlags = {
	FRONTEND_MAINTENANCE_MODE: false,
	FRONTEND_AGENT_MANAGER_PAGE: false,
	FRONTEND_HARDCODED_AGENT_IDS: {},
	FRONTEND_BILLING_PAGE: false,
	FRONTEND_IMPORT_PROGRESS_BAR: false,
	FRONTEND_COMMON_VARS: {},
	FRONTEND_SCHEDULER_MANAGER: false,
}

export const LDConfig = {
	clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID || '',
	reactOptions: {
		useCamelCaseFlagKeys: false,
	},
	context: { kind: 'user', key: 'user-key-prop-ai' },
}

let _launchDarklyClient: LaunchDarkly.LDClient

interface ClientInitializationParams {
	envKey: string
	defaultFlags: LaunchDarkly.LDFlagSet
}

type InitClient = (params: ClientInitializationParams) => {
	getAllFeatureFlags: () => Promise<LaunchDarkly.LDFlagSet>
	getLaunchDarklyClient: () => LaunchDarkly.LDClient
}

const initClient: InitClient = ({ defaultFlags, envKey }) => {
	const getAllFeatureFlags = async (): Promise<LaunchDarkly.LDFlagSet> => {
		const client = await getClient(envKey)

		if (!client) {
			return defaultFlags
		}

		try {
			return client.allFlags()
		} catch (e) {
			console.error('failed to load flags from launchdarkly')
			return defaultFlags
		}
	}

	const getLaunchDarklyClient = () => _launchDarklyClient

	return { getAllFeatureFlags, getLaunchDarklyClient }
}

async function initialize(envKey: string) {
	let client: LaunchDarkly.LDClient

	try {
		client = LaunchDarkly.initialize(envKey, LDConfig.context)
		await client.waitForInitialization()
		return client
	} catch (e) {
		console.error('failed to initialize launchdarkly')
	}
}

async function getClient(envKey: string) {
	if (_launchDarklyClient) return _launchDarklyClient
	// @ts-ignore
	return (_launchDarklyClient = await initialize(envKey))
}

export const { getAllFeatureFlags, getLaunchDarklyClient } = initClient({
	envKey: LDConfig.clientSideID,
	defaultFlags,
})
